/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddConductorRequest as BoLankaContractAddConductorRequest } from '../models/BoLanka/Contract/add-conductor-request';
import { AddConductorResponse as BoLankaContractAddConductorResponse } from '../models/BoLanka/Contract/add-conductor-response';
import { Employer as BoLankaContractEmployer } from '../models/BoLanka/Contract/employer';
import { SetConductorDataRequest as BoLankaContractSetConductorDataRequest } from '../models/BoLanka/Contract/set-conductor-data-request';

@Injectable({
  providedIn: 'root',
})
export class ConductorService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiRoutesPrvIdConductorGet
   */
  static readonly ApiRoutesPrvIdConductorGetPath = '/api/routes/{prvId}/conductor';

  /**
   * ### Claim
   *  boservice.routes.listemp
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoutesPrvIdConductorGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoutesPrvIdConductorGet$Response(params: {
    prvId: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<BoLankaContractEmployer>>> {

    const rb = new RequestBuilder(this.rootUrl, ConductorService.ApiRoutesPrvIdConductorGetPath, 'get');
    if (params) {
      rb.path('prvId', params.prvId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BoLankaContractEmployer>>;
      })
    );
  }

  /**
   * ### Claim
   *  boservice.routes.listemp
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoutesPrvIdConductorGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoutesPrvIdConductorGet(params: {
    prvId: number;
  },
  context?: HttpContext

): Observable<Array<BoLankaContractEmployer>> {

    return this.apiRoutesPrvIdConductorGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<BoLankaContractEmployer>>) => r.body as Array<BoLankaContractEmployer>)
    );
  }

  /**
   * Path part for operation apiRoutesPrvIdConductorPost
   */
  static readonly ApiRoutesPrvIdConductorPostPath = '/api/routes/{prvId}/conductor';

  /**
   * ### Claim
   *  boservice.routes.addconductor
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoutesPrvIdConductorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoutesPrvIdConductorPost$Response(params: {
    prvId: number;
    lang?: string;
    body?: BoLankaContractAddConductorRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<BoLankaContractAddConductorResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ConductorService.ApiRoutesPrvIdConductorPostPath, 'post');
    if (params) {
      rb.path('prvId', params.prvId, {});
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BoLankaContractAddConductorResponse>;
      })
    );
  }

  /**
   * ### Claim
   *  boservice.routes.addconductor
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoutesPrvIdConductorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoutesPrvIdConductorPost(params: {
    prvId: number;
    lang?: string;
    body?: BoLankaContractAddConductorRequest
  },
  context?: HttpContext

): Observable<BoLankaContractAddConductorResponse> {

    return this.apiRoutesPrvIdConductorPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<BoLankaContractAddConductorResponse>) => r.body as BoLankaContractAddConductorResponse)
    );
  }

  /**
   * Path part for operation apiRoutesPrvIdConductorPremIdPut
   */
  static readonly ApiRoutesPrvIdConductorPremIdPutPath = '/api/routes/{prvId}/conductor/{premId}';

  /**
   * ### Claim
   *  boservice.routes.setconductordata
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoutesPrvIdConductorPremIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoutesPrvIdConductorPremIdPut$Response(params: {
    prvId: number;
    premId: number;
    lang?: string;
    body?: BoLankaContractSetConductorDataRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConductorService.ApiRoutesPrvIdConductorPremIdPutPath, 'put');
    if (params) {
      rb.path('prvId', params.prvId, {});
      rb.path('premId', params.premId, {});
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * ### Claim
   *  boservice.routes.setconductordata
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoutesPrvIdConductorPremIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoutesPrvIdConductorPremIdPut(params: {
    prvId: number;
    premId: number;
    lang?: string;
    body?: BoLankaContractSetConductorDataRequest
  },
  context?: HttpContext

): Observable<void> {

    return this.apiRoutesPrvIdConductorPremIdPut$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
